import React, { useEffect, useState } from 'react';

import { LoaderSpinner } from '@vw-marketing/us-components';
import { setUserSecurityPinBooleanToSessionStorage } from '../../shared/utils/pin-session';

import { PinVerificationModal } from './components/PinVerificationModal';
import { StyledPinToastWrapper } from './components/styles';
import Toast from '../../shared/components/toast/Toast';
import { formatLockDuration } from '../../shared/utils/format-lock-duration';
import { useFeatureServices } from '../../shared/hooks/use-feature-services';
import { useHistory } from '../../shared/hooks/use-history';
import { useMyVwContext } from '../../shared/hooks/use-my-vw-context';

const SecurityPinManagement: React.FC = () => {
  const [challenge, setChallenge] = useState<string>('');
  const [isLocked, setIsLocked] = useState<boolean>(false);
  const [lockDuration, setLockDuration] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { authService } = useMyVwContext();
  const { 'locale-service': localeService } = useFeatureServices();
  const localeCode = `${localeService.language}-${localeService.countryCode}`;
  const history = useHistory();

  useEffect(() => {
    const fetchChallenge = async () => {
      try {
        const response = await authService.getUserSecurityPinChallenge(localeCode);
        const data = response?.getUserSecurityPinChallenge;
        setChallenge(data?.challenge ?? '');
        setIsLocked(data?.pinStatus === 'LOCKED');
        if (data?.spinLockedWaitingTimeInSeconds) {
          setLockDuration(formatLockDuration(data.spinLockedWaitingTimeInSeconds));
        }
      } catch {
        console.error('Error fetching security PIN challenge');
      } finally {
        setIsLoading(false);
      }
    };

    fetchChallenge();
  }, []);

  const handlePinVerified = () => {
    setUserSecurityPinBooleanToSessionStorage();
    history.push('/account-settings');
  };

  if (isLoading) {
    return <LoaderSpinner />;
  }

  return (
    <>
      <PinVerificationModal
        challenge={challenge}
        isLocked={isLocked}
        lockDuration={lockDuration}
        onSuccess={handlePinVerified}
      />
      <StyledPinToastWrapper>
        <Toast />
      </StyledPinToastWrapper>
    </>
  );
};

export default SecurityPinManagement;
